import React from 'react';
// import PropTypes from 'prop-types';

import store from '../../../stores/store';
import { LOCK_SYSTEM_ERROR_MSG } from '../../../helpers/messageText';

class ErrorForm extends React.Component {

    /**
         * Build in function used
         * to check if pin exists and is validated
         */
    componentWillMount() {
        if (!window.offlineApiExtension) {
            store.user.logout();
        }
    }

    /**
         * Build in function used
         * to check if pin exists and is validated
         */
        componentDidMount() {
            store.user.setLoggedIn(false);
        }

    render() {
        return (
            <div>
                <p className="alert alert-danger mt-4" role="alert">
                    {LOCK_SYSTEM_ERROR_MSG}
                </p>
            </div>
        );
    }
}

export default ErrorForm;



// WEBPACK FOOTER //
// ./src/containers/PublicArea/components/ErrorForm.js